import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
const AcceptTermsCheckbox = ({ id, children, termId, msgOnInvalid, useNativeValidation = false, autoFocusOnError = true, onChange }) => {
    const [showError, setShowError] = useState(false);
    const targetRef = useRef(null);
    useEffect(() => {
        if (showError && autoFocusOnError && targetRef.current) {
            targetRef.current.focus();
            targetRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [showError, autoFocusOnError]);
    const handleChange = (e) => {
        onChange?.(e.currentTarget.checked);
        if (e.currentTarget.checked) {
            setShowError(false);
            if (useNativeValidation) {
                e.currentTarget.setCustomValidity('');
            }
        }
    };
    const handleInvalid = (e) => {
        if (useNativeValidation) {
            e.currentTarget.setCustomValidity(msgOnInvalid);
        }
        else {
            e.preventDefault();
            setShowError(true);
        }
    };
    return (_jsxs("div", { className: "control-group", children: [_jsx("input", { required: true, type: "checkbox", id: id, onChange: handleChange, onInvalid: handleInvalid, ref: targetRef }), _jsxs("label", { htmlFor: id, style: {
                    fontSize: '1.8rem',
                    fontWeight: 'inherit',
                }, children: [termId && termId, children] }), !useNativeValidation && showError && (_jsx("div", { style: {
                    color: 'red',
                    fontSize: '1.4rem',
                    marginTop: '0.5rem',
                }, children: msgOnInvalid }))] }));
};
export default AcceptTermsCheckbox;
